import { FilterIcon } from './filter-icon'
import styles from './intensity-filter.module.scss'
import { SidebarFilterSection } from './sidebar-filter-section'
import { useFilterContext } from '../../context/filter-context'
import { Intensity } from '../../dao/core-dao'
import { useWorkoutIntensities } from '../../hook/use-workouts'
import React from 'react'

export const IntensityFilter = (): React.ReactElement => {
  const { workoutFilter, toggleFilterEntry } = useFilterContext()
  const { data: availableIntensities = [] } = useWorkoutIntensities()

  const handleToggleSelectedIntensity = ({ id }: Intensity): void => {
    toggleFilterEntry('intensities', id)
  }

  const renderIntensity = (intensity: Intensity, additionalClass?: string): React.ReactElement => {
    const isActive = workoutFilter?.intensities?.includes(intensity.id) ?? false
    return (
      <span
        className={`${styles.intensityItemContainer} ${additionalClass}`}
        onClick={() => handleToggleSelectedIntensity(intensity)}
      >
        <div className="h-[36px] w-[36px] flex items-center justify-center">
          <FilterIcon filterEntry={intensity} active={isActive} />
        </div>
        <span className="font-roboto-condensed font-semibold text-xs leading-4 tracking-[0.5px] text-ivory pl-[0.6rem]">
          {intensity.label}
        </span>
      </span>
    )
  }
  return <SidebarFilterSection title={'Intensity'} items={availableIntensities} renderItem={renderIntensity} />
}
